import * as fromDatatype from "../datatype-library/index";

export interface bl_sfa_project_qualification_criteria_set_link_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
    project_guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_set_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    priority: fromDatatype.IntegerDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_sfa_project_qualification_criteria_set_link_RowClass
	implements bl_sfa_project_qualification_criteria_set_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
    project_guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_set_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    priority: fromDatatype.IntegerDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
